import { render, staticRenderFns } from "./ContentLoadingFourGrid.vue?vue&type=template&id=b6315dc0"
import script from "./ContentLoadingFourGrid.vue?vue&type=script&lang=js"
export * from "./ContentLoadingFourGrid.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports